export default __webpack_public_path__ + "static/media/home-menu-icon-white.d94e760f.svg";